export default __webpack_public_path__ + "static/pastry-2-271413b6da5e8c3e85bbcd1e71f71a8d.jpg";